var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vks-section-drawers",
      class: {
        "is-rail-pinned": _vm.railPinned,
        "has-open": Boolean(_vm.openSection),
      },
      style: _vm.railPinStyle,
    },
    [
      _vm.openSection
        ? _c("div", {
            staticClass: "vks-section-drawer-backdrop",
            attrs: { role: "presentation" },
            on: {
              click: function ($event) {
                return _vm.$emit("toggle-drawer", _vm.openDrawerId)
              },
            },
          })
        : _vm._e(),
      _c(
        "aside",
        {
          staticClass: "vks-section-drawer-panel",
          class: { "is-open": Boolean(_vm.openSection) },
          attrs: { "aria-hidden": _vm.openSection ? "false" : "true" },
        },
        [
          _vm.openSection
            ? [
                _c("header", { staticClass: "vks-section-drawer-head" }, [
                  _c("h3", { staticClass: "vks-section-drawer-title" }, [
                    _vm._v(_vm._s(_vm.openSection.label)),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "vks-section-drawer-close",
                      attrs: {
                        type: "button",
                        "aria-label": "Close " + _vm.openSection.label,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("toggle-drawer", _vm.openDrawerId)
                        },
                      },
                    },
                    [_vm._v(" × ")]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "vks-section-drawer-body" },
                  [
                    _vm.openSection.id === "associations"
                      ? _c("VariantSifterAssociationsDrawer", {
                          attrs: {
                            rows: _vm.associationsDrawerRows,
                            "filters-index": _vm.associationsState.filtersIndex,
                            loading: _vm.associationsState.loading,
                            "hide-loading-status": _vm.regionLoadProgressActive,
                            error: _vm.associationsState.error,
                            "index-name": _vm.associationsState.index,
                            "query-string": _vm.associationsState.query,
                            "search-session": _vm.searchSession,
                            utils: _vm.utils,
                            "ld-loading": _vm.associationsState.ldLoading,
                            "ld-error": _vm.associationsState.ldError,
                            "ancestry-bubbles": _vm.ancestryBubbles,
                            "ancestry-bubble-groups": _vm.ancestryBubbleGroups,
                            "primary-ancestry": _vm.primaryAncestry,
                            "selected-ancestries":
                              _vm.associationsState.selectedAncestries,
                            "selected-phenotypes":
                              _vm.associationsState.selectedPhenotypes,
                            "ancestry-series-loading":
                              _vm.associationsState.ancestrySeriesLoading,
                            "ancestry-availability-loading":
                              _vm.associationsState.ancestryAvailabilityLoading,
                            "ancestry-availability-error":
                              _vm.associationsState.ancestryAvailabilityError,
                            "project-id": _vm.projectId,
                            "plot-overlays-state": _vm.plotOverlaysState,
                            "plot-markers": _vm.plotMarkers,
                            "starred-variant-ids": _vm.starredVariantIds,
                            "credible-sets-state": _vm.credibleSetsState,
                            "global-enrichment-state":
                              _vm.globalEnrichmentState,
                            "v2g-state": _vm.v2gState,
                            "s2g-state": _vm.s2gState,
                            "mapping-state": _vm.mappingState,
                            "workspace-mapping-filter":
                              _vm.workspaceMappingFilter,
                          },
                          on: {
                            "update:filtersIndex": function ($event) {
                              return _vm.$emit(
                                "update:associationsFiltersIndex",
                                $event
                              )
                            },
                            "toggle-ancestry": function ($event) {
                              return _vm.$emit(
                                "toggle-association-ancestry",
                                $event
                              )
                            },
                            "toggle-star-variant": function ($event) {
                              return _vm.$emit("toggle-star-variant", $event)
                            },
                            "set-reference-variant": function ($event) {
                              return _vm.$emit("set-reference-variant", $event)
                            },
                            "update:mappingState": function ($event) {
                              return _vm.$emit("update:mappingState", $event)
                            },
                          },
                        })
                      : _vm.openSection.id === "credible-sets"
                      ? _c("VariantSifterCredibleSetsDrawer", {
                          attrs: {
                            "credible-sets-state": _vm.credibleSetsState,
                            "color-by-set-id": _vm.credibleSetPillColors,
                            "search-session": _vm.searchSession,
                            utils: _vm.utils,
                            "starred-variant-ids": _vm.starredVariantIds,
                          },
                          on: {
                            "add-set": function ($event) {
                              return _vm.$emit("add-credible-set", $event)
                            },
                            "remove-set": function ($event) {
                              return _vm.$emit("remove-credible-set", $event)
                            },
                            "toggle-star-variant": function ($event) {
                              return _vm.$emit("toggle-star-variant", $event)
                            },
                            "update:panelFilters": function ($event) {
                              return _vm.$emit(
                                "update:credibleSetsPanelFilters",
                                $event
                              )
                            },
                          },
                        })
                      : _vm.openSection.id === "genes"
                      ? _c("GP2BrowserGenesDrawer", {
                          attrs: { "genes-state": _vm.genesState },
                          on: {
                            "update:selectedTypes": function ($event) {
                              return _vm.$emit(
                                "update:genesSelectedTypes",
                                $event
                              )
                            },
                          },
                        })
                      : _vm.openSection.id === "qtl-evidences"
                      ? _c("GP2BrowserQtlDrawer", {
                          attrs: {
                            "qtl-state": _vm.qtlState,
                            "plot-markers": _vm.plotMarkers,
                            utils: _vm.utils,
                          },
                          on: {
                            "update:selectedTypes": function ($event) {
                              return _vm.$emit(
                                "update:qtlSelectedTypes",
                                $event
                              )
                            },
                            "update:selectedTissues": function ($event) {
                              return _vm.$emit(
                                "update:qtlSelectedTissues",
                                $event
                              )
                            },
                            "update:selectedGenes": function ($event) {
                              return _vm.$emit(
                                "update:qtlSelectedGenes",
                                $event
                              )
                            },
                            "update:pValueMax": function ($event) {
                              return _vm.$emit("update:qtlPValueMax", $event)
                            },
                            "toggle-star-variant": function ($event) {
                              return _vm.$emit(
                                "toggle-qtl-star-variant",
                                $event
                              )
                            },
                          },
                        })
                      : _vm.openSection.id === "global-enrichment"
                      ? _c("VariantSifterGlobalEnrichmentDrawer", {
                          attrs: {
                            "global-enrichment-state":
                              _vm.globalEnrichmentState,
                            "search-session": _vm.searchSession,
                            utils: _vm.utils,
                            "hide-loading-status": _vm.regionLoadProgressActive,
                          },
                          on: {
                            "update:enabledMutedAnnotations": function (
                              $event
                            ) {
                              return _vm.$emit(
                                "update:geEnabledMutedAnnotations",
                                $event
                              )
                            },
                            "update:enabledMutedAnnotationTissues": function (
                              $event
                            ) {
                              return _vm.$emit(
                                "update:geEnabledMutedAnnotationTissues",
                                $event
                              )
                            },
                            "update:disabledAnnotationTissues": function (
                              $event
                            ) {
                              return _vm.$emit(
                                "update:geDisabledAnnotationTissues",
                                $event
                              )
                            },
                            "update:selectedAnnotations": function ($event) {
                              return _vm.$emit(
                                "update:geSelectedAnnotations",
                                $event
                              )
                            },
                            "update:tissueTrackSort": function ($event) {
                              return _vm.$emit(
                                "update:geTissueTrackSort",
                                $event
                              )
                            },
                            "update:geTrackPValueMax": function ($event) {
                              return _vm.$emit(
                                "update:geTrackPValueMax",
                                $event
                              )
                            },
                            "update:selectedMethods": function ($event) {
                              return _vm.$emit(
                                "update:geSelectedMethods",
                                $event
                              )
                            },
                            "update:selectedSources": function ($event) {
                              return _vm.$emit(
                                "update:geSelectedSources",
                                $event
                              )
                            },
                          },
                        })
                      : _vm.openSection.id === "variant-to-gene-links"
                      ? _c("VariantSifterV2gDrawer", {
                          attrs: {
                            "v2g-state": _vm.v2gState,
                            "global-enrichment-state":
                              _vm.globalEnrichmentState,
                            "search-session": _vm.searchSession,
                            "view-region": _vm.viewRegion,
                            utils: _vm.utils,
                          },
                          on: {
                            "update:selectedTissues": function ($event) {
                              return _vm.$emit(
                                "update:v2gSelectedTissues",
                                $event
                              )
                            },
                            "update:deselectedMethods": function ($event) {
                              return _vm.$emit(
                                "update:v2gDeselectedMethods",
                                $event
                              )
                            },
                            "update:deselectedGenes": function ($event) {
                              return _vm.$emit(
                                "update:v2gDeselectedGenes",
                                $event
                              )
                            },
                            "update:deselectedTissues": function ($event) {
                              return _vm.$emit(
                                "update:v2gDeselectedTissues",
                                $event
                              )
                            },
                            "update:deselectedBiosamples": function ($event) {
                              return _vm.$emit(
                                "update:v2gDeselectedBiosamples",
                                $event
                              )
                            },
                          },
                        })
                      : _vm.openSection.id === "snp2gene-links"
                      ? _c("VariantSifterS2gDrawer", {
                          attrs: {
                            "s2g-state": _vm.s2gState,
                            "search-session": _vm.searchSession,
                            "view-region": _vm.viewRegion,
                            utils: _vm.utils,
                          },
                          on: {
                            load: function ($event) {
                              return _vm.$emit("load-s2g")
                            },
                            clear: function ($event) {
                              return _vm.$emit("clear-s2g")
                            },
                            "update:deselectedGenes": function ($event) {
                              return _vm.$emit(
                                "update:s2gDeselectedGenes",
                                $event
                              )
                            },
                          },
                        })
                      : [
                          _c("p", { staticClass: "vks-section-drawer-note" }, [
                            _vm._v(_vm._s(_vm.openSection.description)),
                          ]),
                          _c("p", { staticClass: "vks-section-drawer-note" }, [
                            _vm._v(
                              " Search and filter UI for this section will appear here. "
                            ),
                          ]),
                        ],
                  ],
                  2
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "vks-section-drawer-tabs",
          attrs: { role: "tablist", "aria-label": "Section controls" },
        },
        _vm._l(_vm.sections, function (section) {
          return _c(
            "button",
            {
              key: section.id,
              staticClass: "vks-section-drawer-tab",
              class: {
                "is-active": section.id === _vm.openDrawerId,
                "is-attached":
                  section.id === _vm.openDrawerId && Boolean(_vm.openDrawerId),
              },
              style: _vm.tabStyle(section),
              attrs: {
                type: "button",
                role: "tab",
                "aria-selected":
                  section.id === _vm.openDrawerId ? "true" : "false",
                title: section.label,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("toggle-drawer", section.id)
                },
              },
            },
            [
              _c("span", { staticClass: "vks-section-drawer-tab-label" }, [
                _vm._v(_vm._s(_vm.drawerTabLabel(section))),
              ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }